import React, { Component } from 'react';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, MainColumn, Figure, OneHalf, KeySection, SideColumnBookLeft, SideColumnBookRight } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { HeadingH1, HeadingH2, DropCap, BulletedList } from '../../theme/typography';
import Header from '../../components/Header/Header';
import CallToolsRedesign from '../../assets/CallTools/Redesign/Redesign';
import CallToolsMobile from '../../assets/CallTools/Mobile/Mobile';
import { Icon } from '../../theme/assets';
import { Caption } from '../../theme/typography';
import ReviewPlugin from '../../assets/Amazon/ReviewPlugin/ReviewPlugin';
import PageFooter from '../../components/PageFooter/PageFooter';
import Footer from '../../components/Footer/Footer';

export default class DesignReviewPlugin extends Component {
  static propTypes = {};
  
  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);
      
      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }
      
  }
  
  

  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
          <Header theme={"amazon " + this.state.messageShown} color="#0077FF" date="Summer 2020" role="Design, Development" action={this.handler}></Header>
          <Article className={"amazon " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
                <Heading className={this.state.messageShown}>
                  <HeadingH2 className="amazon">Amazon</HeadingH2>
                  <HeadingH1>Review Plugin</HeadingH1>
                  <OverlaySummery className={this.state.messageShown}>
                    <p>Amazon's book review platform, Goodreads, let's readers write about and recommend books. </p>
                    <ul>
                      <li>Imports Layer Styles</li>
                      <li>Interchangable Layer Styles</li>
                      <li>Updates Layer Fills</li>
                    </ul>
                  </OverlaySummery>
                </Heading>
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>A</DropCap>mazon's book review platform, Goodreads, helps people keep track of the books they've read. In the Spring of 2020, the Goodreads team created a design system to maintain visual consisteny across their mobile and web apps. This effort included the creation of design tokens and defining rules about the appropriate use of content and design elements.</p>
                  <p>Once the system was in place, the team's daily design reviews quickly shifted from talking about the experience we are trying to create to talking about whether or not designs were following the rules established by the systen. This wasn't an efficient use of our time, so I built a Sketch plugin that automatically checks whether layers, groups, symbols, and artboards are following our content guidelines and using our design tokens.</p>
                </MainColumn>
              </FirstSection>
              <KeySection className={this.state.messageShown}>
                <ReviewPlugin />
                <Caption><Icon src={require('../../icons/touch-yellow.gif')} alt="icon"/>Hey, you can try this!</Caption>
              </KeySection>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Features</h2>
                  <p>This Sketch Plugin has several features which help ensure that our designs are meeting our design standards. Open the plugin, place it next to your sektch window and watch it review your designs as you work. The plugin will identify any errors or inconsistencies in your design and gives you the option to fix those issues.</p>
                  <BulletedList>
                    <li>
                        <b>Checks Layer List</b>
                        <p>Works with Layers, Groups, Artboards, and Symbols.</p>
                    </li>
                    <li>
                        <b>Idenitfies Errors</b>
                        <p>The plugin traverses your layer list looking for any element that is inconsistent with our design tokens.</p>
                    </li>
                    <li>
                        <b>Offers Solutions</b>
                        <p>When an error is identified a solution is offered and that element can be updated.</p>
                    </li>
                    <li>
                        <b>Uses Design Tokens</b>
                        <p>Built with the same set of design tokens developers use to create the Goodreads apps.</p>
                    </li>
                    <li>
                        <b>Constantly Running</b>
                        <p>Place the plugin next to your Sketch window and watch it review your work in real time.</p>
                    </li>
                    
                  </BulletedList>
                </MainColumn>
                <SideColumnBookLeft>
                  <img alt="" src={require('../../assets/Amazon/book-yellow1.png')} />
                </SideColumnBookLeft>
              </Section>
            </Container>
          </Article>
          <PageFooter theme="amazon" present={this.state.messageShown} leftTitle="Amazon" left="Data Plugin" leftLink="amazon-data-plugin" rightTitle="Mozilla" right="Design Tokens" rightLink="mozilla-design-tokens"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/AmazonDesignReviewPlugin/DesignReviewPlugin.js